const font = {
  // Roboto: {
  //   normal: `${window.location.origin}/font/Roboto-Regular.ttf`,
  //   bold: `${window.location.origin}/font/Roboto-Regular.ttf`,
  //   italics: `${window.location.origin}/font/Roboto-Regular.ttf`,
  //   bolditalics: `${window.location.origin}/font/Roboto-Regular.ttf`
  // },

  // 微软雅黑: {
  //   normal: `${window.location.origin}/font/%E5%BE%AE%E8%BD%AF%E9%9B%85%E9%BB%91.ttf`,
  //   bold: `${window.location.origin}/font/%E5%BE%AE%E8%BD%AF%E9%9B%85%E9%BB%91.ttf`,
  //   italics: `${window.location.origin}/font/%E5%BE%AE%E8%BD%AF%E9%9B%85%E9%BB%91.ttf`,
  //   bolditalics: `${window.location.origin}/font/%E5%BE%AE%E8%BD%AF%E9%9B%85%E9%BB%91.ttf`
  // },
  
  普惠体: {
    normal: `${window.location.origin}/font/Alibaba_PuHuiTi_2.0_55_Regular_55_Regular.ttf`,
    bold: `${window.location.origin}/font/Alibaba_PuHuiTi_2.0_55_Regular_85_Bold.ttf`,
    italics: `${window.location.origin}/font/Alibaba_PuHuiTi_2.0_55_Regular_55_Regular.ttf`,
    bolditalics: `${window.location.origin}/font/Alibaba_PuHuiTi_2.0_55_Regular_85_Bold.ttf`
  }
};

export default font;
